export interface DeepLinkWizardProps {
  className?: string;
}

export enum DeepLinkWizardSteps {
  'init' = 'init',
  'login' = 'login',
}
